import { Flex } from '@chakra-ui/react';
import React from 'react';
import './CustomFormFieldLabel.scss';

interface CustomFormLabelProps {
  label: string;
  isRequired: boolean;
  isDisabled: boolean;
  size?: 'sm' | 'md' | 'lg';
}

const CustomFormFieldLabel = ({
  label,
  isRequired,
  isDisabled,
  size = 'md',
}: CustomFormLabelProps) => {
  const isDisabledClassName = isDisabled ? 'disabled' : '';

  return (
    <Flex className={'custom-form-field-label-container'}>
      <span
        className={`custom-form-field-label ${size} ${isDisabledClassName}`}
      >
        {label}
      </span>

      {!isRequired && (
        <span className={'custom-form-field-optional-label'}>(Optional)</span>
      )}
    </Flex>
  );
};

export default CustomFormFieldLabel;
